import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useState, useEffect } from 'react';
import axios from 'axios';
import { formatPayload } from './helpers.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var useSortingHatV3 = function useSortingHatV3(_ref) {
  var trackFields = _ref.trackFields,
    decisionFields = _ref.decisionFields,
    trackEvent = _ref.trackEvent,
    decisionRequestEvent = _ref.decisionRequestEvent,
    decisionReceivedEvent = _ref.decisionReceivedEvent,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isDev = _ref.isDev,
    isDev = _ref$isDev === void 0 ? true : _ref$isDev,
    _ref$workflowId = _ref.workflowId,
    workflowId = _ref$workflowId === void 0 ? "w1" : _ref$workflowId,
    _ref$key = _ref.key,
    key = _ref$key === void 0 ? {
      dev: "9eOire7PmD8ppguDDkJw177uABawhOen2YfX4QV3",
      prod: "H6kzEu8WCQ4gVPsNDNiTb9Xu4CqYPlCMaHVMVtRF"
    } : _ref$key,
    _ref$extraTrackData = _ref.extraTrackData,
    extraTrackData = _ref$extraTrackData === void 0 ? {} : _ref$extraTrackData;
  var apiRoot = isDev ? "https://sh.dev.iq.com.br" : "https://sh.iq.com.br";
  var apiConfig = {
    headers: {
      "x-api-key": isDev ? key.dev : key.prod
    }
  };
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isShActive = _useState2[0],
    setIsShActive = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    formFilled = _useState4[0],
    setFormFilled = _useState4[1];
  useEffect(function () {
    return checkShActive();
  }, []);
  function checkShActive() {
    var shParam = new URLSearchParams(window.location.search).get("utm_sh");
    var useUtmDecision = shParam === "true";
    var isActive = shParam ? useUtmDecision : !disabled;
    return setIsShActive(isActive);
  }
  function shTrack(fieldSlug, inputValue) {
    var fieldsPayload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var isValid = arguments.length > 3 ? arguments[3] : undefined;
    var checkDocument = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var _a, _b;
    try {
      var fullPayload = __spreadValues(__spreadValues({}, fieldsPayload), extraTrackData);
      var formattedPayload = formatPayload(fullPayload);
      var isDocumentValid = (formattedPayload == null ? void 0 : formattedPayload["document"]) && ((_a = formattedPayload == null ? void 0 : formattedPayload["document"]) == null ? void 0 : _a.length) >= 11 && ((_b = formattedPayload == null ? void 0 : formattedPayload["document"]) == null ? void 0 : _b.indexOf("_")) === -1;
      var documentValidationPassed = !checkDocument || isDocumentValid;
      var runSH = (trackFields == null ? void 0 : trackFields.includes(fieldSlug)) || !trackFields;
      var alreadySent = formFilled[fieldSlug] === inputValue;
      var invalidField = !isValid || (inputValue == null ? void 0 : inputValue.length) === 0;
      setFormFilled(function (prevState) {
        return __spreadProps(__spreadValues({}, prevState), _defineProperty({}, fieldSlug, inputValue));
      });
      if (!runSH || alreadySent || !isShActive || invalidField || !documentValidationPassed) return;
      if (!!trackEvent) trackEvent({
        fieldSlug: fieldSlug,
        inputValue: inputValue,
        fullPayload: fullPayload
      });
      var encodedPayload = {
        data: window == null ? void 0 : window.btoa(JSON.stringify(formattedPayload))
      };
      axios.post("".concat(apiRoot, "/track"), encodedPayload, apiConfig);
    } catch (e) {
      console.error("[SH TRACK ERROR]", e);
    }
  }
  function shDecision(formPayload) {
    return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a, _b, _c, _d, _e, resultDefault, fireboltId, identifier, choosenCard, SHPayload, encodeFormattedPayload, payload, _yield$axios$post, status, data, eventPayload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resultDefault = {
              firstDecisionItem: "current",
              result: {
                decisions: [{
                  id: "current"
                }]
              },
              resultType: "modal"
            };
            _context.prev = 1;
            fireboltId = extraTrackData.fireboltId, identifier = extraTrackData.identifier, choosenCard = extraTrackData.choosenCard;
            if (!(!fireboltId && !identifier)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", resultDefault);
          case 5:
            SHPayload = {
              identifier: fireboltId || identifier,
              workflow_id: workflowId
            };
            encodeFormattedPayload = window == null ? void 0 : window.btoa(JSON.stringify(SHPayload));
            payload = JSON.stringify({
              data: encodeFormattedPayload
            });
            if (!!decisionRequestEvent) {
              decisionRequestEvent(formPayload);
            }
            _context.next = 11;
            return axios.post("".concat(apiRoot, "/decide"), payload, apiConfig);
          case 11:
            _yield$axios$post = _context.sent;
            status = _yield$axios$post.status;
            data = _yield$axios$post.data;
            if (status === 200 && !!decisionReceivedEvent) {
              eventPayload = {
                result: data == null ? void 0 : data.result,
                enabled: data == null ? void 0 : data.enabled
              };
              decisionReceivedEvent(formPayload, eventPayload);
            }
            if (!(!data.enabled || ((_b = (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.decisions[0]) == null ? void 0 : _b.id) === choosenCard)) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", resultDefault);
          case 17:
            return _context.abrupt("return", {
              firstDecisionItem: ((_d = (_c = data == null ? void 0 : data.result) == null ? void 0 : _c.decisions[0]) == null ? void 0 : _d.id) || resultDefault.firstDecisionItem,
              result: {
                decisions: ((_e = data == null ? void 0 : data.result) == null ? void 0 : _e.decisions) || resultDefault.result.decisions
              },
              resultType: (data == null ? void 0 : data.result_type) || resultDefault.resultType
            });
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](1);
            console.error("[SH DECISION ERROR]", _context.t0);
            return _context.abrupt("return", resultDefault);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 20]]);
    }));
  }
  return {
    isShActive: isShActive,
    shTrack: shTrack,
    shDecision: shDecision
  };
};
export { useSortingHatV3 as default };